(function () {
  const waitForPayPal = (callback, attempts = 0) => {
    if (window.paypal && typeof paypal.Messages === 'function') {
      callback();
      return;
    }
    if (attempts > 120) return;
    setTimeout(() => waitForPayPal(callback, attempts + 1), 100);
  };

  const parsePriceCents = (value) => {
    if (value == null || value === '') return NaN;
    const n = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (isNaN(n)) return NaN;
    return Math.round(n);
  };

  const initContainer = (container) => {
    if (container.dataset.paypalMessagesBound === 'true') return;
    container.dataset.paypalMessagesBound = 'true';

    const sectionId = container.dataset.sectionId;
    if (!sectionId) return;

    let variantPriceCents = parsePriceCents(container.dataset.initialVariantPrice);
    if (isNaN(variantPriceCents)) variantPriceCents = 0;

    let renderSeq = 0;

    const getQty = () => {
      const el = document.getElementById(`Quantity-${sectionId}`);
      if (!el) return 1;
      const q = parseInt(el.value, 10);
      if (isNaN(q) || q < 1) return 1;
      return q;
    };

    const lineTotalCents = () => variantPriceCents * getQty();

    const render = () => {
      waitForPayPal(() => {
        container.innerHTML = '';
        renderSeq += 1;
        const inner = document.createElement('div');
        inner.id = `PayPalMessagesInner-${sectionId}-${renderSeq}`;
        container.appendChild(inner);

        const amount = (lineTotalCents() / 100).toFixed(2);
        const currency = container.dataset.currency || 'USD';
        const config = {
          amount,
          currency,
          placement: 'product',
          style: { layout: 'text' },
        };
        if (container.dataset.buyerCountry) {
          config.buyerCountry = container.dataset.buyerCountry;
        }
        try {
          paypal.Messages(config).render(`#${inner.id}`);
        } catch (e) {
          console.error('PayPal Messages render failed', e);
        }
      });
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event?.data) return;
        if (String(event.data.sectionId) !== String(sectionId)) return;
        const v = event.data.variant;
        if (v?.price != null) {
          const cents = parsePriceCents(v.price);
          if (!isNaN(cents)) variantPriceCents = cents;
        }
        render();
      });

      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        render();
      });
    }

    const qtyInput = document.getElementById(`Quantity-${sectionId}`);
    if (qtyInput) {
      qtyInput.addEventListener('change', render);
      qtyInput.addEventListener('input', render);
    }

    render();
  };

  const init = () => {
    document.querySelectorAll('[data-paypal-messages-product]').forEach(initContainer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
